import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function fetchMyBlogPosts(options = {}) {
  return function withContext(context) {
    const { skip = 0, take = 20 } = options;
    const params = new URLSearchParams({ skip, take });
    const url = `${API_URL}blog/my/posts?${params.toString()}`;
    return _fetch(url, { withAuth: true }, { method: 'GET' })(context);
  };
}
